'use strict';

angular.module("app").controller("GlobalController",["$scope","$window","tools","webservice","parameters","user","config",
                                                     function($scope,$window,tools,webservice,parameters,user,config) {
  $scope.tools = tools;
  $scope.webservice=webservice;
  $scope.parameters = parameters;
  $scope.user=user;
  $scope.config=config;

  if(user.lang===null) {
    if($window.lang) {
      user.lang=$window.lang;
    } else {
      user.lang=config.get("defaultLang");
    }
  }
  
}]);
